import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { userCoin } from "@/api/data";
import serverList from "../../../components/serverList/serverOptions.vue";
import infoList from "@/mixins/infoList";
import DateOptions from "../../../components/timeList/dateOptions.vue";
import { formatTimeToStr } from "@/utils/date.js";
import userCoinLine from "../components/userCoinLine.vue";
import { getGameCoinMap } from "@/utils/dictionary";
export default {
  mixins: [infoList],
  components: {
    serverList: serverList,
    DateOptions: DateOptions,
    userCoinLine: userCoinLine
  },
  data: function data() {
    return {
      listApi: userCoin,
      searchInfo: {
        server_id: []
      },
      formData: [this.$moment().subtract(7, "days").format("YYYY-MM-DD"), this.$moment().format("YYYY-MM-DD")],
      coinList: {}
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            // this.result = this.cal.accMul(2, 0.6);
            _this.formatTimeToStr = formatTimeToStr;
            _this.searchEvent();
            _context.next = 4;
            return getGameCoinMap();
          case 4:
            _this.coinList = _context.sent;
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    searchEvent: function searchEvent() {
      this.searchInfo.sdate = this.formData[0];
      this.searchInfo.edate = this.formData[1];
      this.loadTableData();
    },
    loadTableData: function loadTableData() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this2.loading = true;
              _context2.next = 3;
              return _this2.getTableData();
            case 3:
              //对 Table 进行重新布局。当 Table 或其祖先元素由隐藏切换为显示时，可能需要调用此方法
              //否则出现表格混乱
              _this2.$refs["table"].doLayout();
              _this2.loading = false;
              _this2.$refs.userCoinLine.initCharts();
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    getSummaries: function getSummaries(param) {
      var _this3 = this;
      var columns = param.columns;
      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (column.property == "activity_user" || column.property == "history_pay_user" || column.property == "pay_user") {
          sums[index] = _this3.tableDataCount[column.property];
          return;
        }
        if (column.property == "activity_user_coin_avg") {
          sums[index] = _this3.tableDataCount['activity_user'] > 0 ? parseInt(_this3.tableDataCount['activity_user_coin'] / _this3.tableDataCount['activity_user']) : 0;
          return;
        }
        if (column.property == "history_pay_user_coin_avg") {
          sums[index] = _this3.tableDataCount['activity_user'] > 0 ? parseInt(_this3.tableDataCount['history_pay_user_coin'] / _this3.tableDataCount['history_pay_user']) : 0;
          return;
        }
        if (column.property == "pay_user_coin_avg") {
          sums[index] = _this3.tableDataCount['pay_user'] > 0 ? parseInt(_this3.tableDataCount['pay_user_coin'] / _this3.tableDataCount['pay_user']) : 0;
          return;
        }
      });
      return sums;
    }
  }
};